<template>
  <component
    :is="as"
    @click="$emit('click')"
    :style="`width: ${width}px; height: ${height}px;`"
    :class="[bg, { 'm-auto': center }, { 'rounded-circle': circle }]"
  >
    <b-img
      fluid
      :class="`bg-${color}`"
      v-if="customSvgColor"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA
           AEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII="
      :style="customStyle"
    >
    </b-img>
    <b-img v-else fluid :src="svgSrc" :width="width" :height="height"></b-img>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type SvgIconProps = {
  icon: string
  width?: number | string
  height?: number | string
  circle?: boolean
  bg?: string
  color?: string
  center?: boolean
  as?: 'div' | 'span' | 'a'
  display?: 'block' | 'inline-block' | 'inline'
}

const props = withDefaults(defineProps<SvgIconProps>(), {
  width: 24,
  height: 24,
  circle: true,
  bg: '',
  color: 'white',
  center: false,
  as: 'div',
  display: 'block'
})

const customStyle = computed(() => ({
  display: props.display,
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  maskSize: 'cover',
  margin: 'auto',
  width: `${props.width}px`,
  height: `${props.height}px`,
  maskImage: 'url("' + svgSrc.value + '")'
}))

const customSvgColor = computed<boolean>(() => props.color !== 'initial')

const svgSrc = computed<string>(
  () => new URL(`/src/assets/svg/${props.icon}.svg`, import.meta.url).href
)
</script>
